import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { InternalGeneralContent } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemInternalTransaction from '../hooks/use-internal';

const ProblemInternalGeneralContentHOC = (): React.JSX.Element => {
  const { transaction } = useAppSelector(
    (state) => state.customersProblemTransactions.internal,
  );
  const { overdraftEnabled } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { currencies: currenciesList } = useAppSelector((state) => state.root);

  const { transactionId } = useParams();

  const {
    getAccountsBalanceAction,
    senderAccountBalance,
    recipientAccountBalance,
    senderBalances,
    recipientBalances,
    senderBalanceIsLoading,
    senderBalanceIsFetching,
    recipientBalanceIsLoading,
    recipientBalanceIsFetching,
  } = useProblemInternalTransaction({
    transactionId,
    transaction,
  });

  useEffect(() => {
    if (transaction) {
      getAccountsBalanceAction();
    }
  }, [transaction]);

  return (
    <InternalGeneralContent
      transactionUrlType="internal"
      general={transaction}
      currenciesList={currenciesList}
      senderAccountBalance={senderAccountBalance}
      recipientAccountBalance={recipientAccountBalance}
      currencyId={transaction?.currencyId}
      senderAccountBalances={senderBalances}
      recipientAccountBalances={recipientBalances}
      senderAccountBalancesIsLoading={
        senderBalanceIsLoading || senderBalanceIsFetching
      }
      recipientAccountBalancesIsLoading={
        recipientBalanceIsLoading || recipientBalanceIsFetching
      }
      overdraftEnabled={overdraftEnabled}
      recipientAccountsWithInfo={[transaction?.recipientAccount]}
      senderAccountsWithInfo={[transaction?.senderAccount]}
      availableCurrencies={currenciesList?.map((item) => ({
        name: item.name,
        value: item.id,
      }))}
      allCurrenciesList={currenciesList?.map((item) => ({
        name: item.name,
        value: item.id,
      }))}
      currencyName={transaction?.currency?.name}
      transactionId={transactionId}
      withTransactionUrl
    />
  );
};

export default ProblemInternalGeneralContentHOC;
